import * as React from 'react';
import styled from 'styled-components';

import { color } from 'styles/utils';

import Layout from 'components/Layout';
import SEO from 'components/SEO';

import Hero from 'pageComponents/Team/Hero';
import OurMission from 'pageComponents/Team/OurMission';
import OurValues from 'pageComponents/Team/OurValues';
import OurFounders from 'pageComponents/Team/OurFounders';
import OurInvestors from 'pageComponents/Team/OurInvestors';
import RecentNews from 'pageComponents/Team/RecentNews';
import GetTheGuide from 'pageComponents/Team/GetTheGuide';

const StyledLayout = styled(Layout)`
  background-color: ${color('darkestTeal')};
  color: ${color('white')};
  position: relative;
`;

export default function TeamPage(props) {
  return (
    <StyledLayout {...props}>
      <Hero />
      <OurMission />
      <OurValues />
      <OurFounders />
      <OurInvestors />
      <RecentNews />
      <GetTheGuide />
    </StyledLayout>
  );
}

export function Head({ location }) {
  return (
    <SEO
      title="Founders and Team"
      description="Sleuth is founded by early employees of Atlassian, including a founding engineer at JIRA, the GM of Atlassian Cloud, and an accomplished Java engineer and author."
      location={location}
    />
  );
}
